/* eslint-disable */
import LazyLoad from "vanilla-lazyload";
import inView from "in-view";
import gsap from "gsap";
import Flickity from "flickity";
import Cookies from "js-cookie";
import { Rive, RuntimeLoader } from "@rive-app/canvas";
import { ScrollTrigger } from "gsap/ScrollTrigger";
import { DrawSVGPlugin } from "gsap/DrawSVGPlugin";

gsap.registerPlugin(ScrollTrigger, DrawSVGPlugin);
// RuntimeLoader.setWasmUrl('/wp-content/themes/nc/static/animation/rive.wasm');

const HTML = document.querySelector("html");
let timerThrottle = 0;

class App {
  constructor() {

    this.lazyload = new LazyLoad({
      unobserve_entered: true,
      elements_selector: ".js-lazy",
      threshold: window.innerHeight * 0.8,
      // eslint-disable-next-line camelcase
      callback_enter: ($el) => {
        if ($el.classList.contains("js-lazy-error-placeholder")) {
          $el.lazyLoadPlaceholder = $el.src;
        } else if ($el.dataset.src == undefined) {
          const figure = $el.closest("figure");
          if (figure) figure.classList.add("img-is-loaded");
        }
      },
      callback_loaded: (el) => {
        const figure = el.closest("figure");
        if (figure) figure.classList.add("img-is-loaded");
      },
      // eslint-disable-next-line camelcase
      callback_error: ($el) => {
        if ($el.lazyLoadPlaceholder) {
          $el.src = $el.lazyLoadPlaceholder;
        }
      },
    });

    /** * TOGGLE MENU */
    const toggleMenus = document.querySelectorAll(".toggle-menu");
    if (toggleMenus) {
      toggleMenus.forEach((toggle) => {
        toggle.addEventListener("click", (e) => {
          e.preventDefault();

          HTML.classList.toggle("open-menu");
        });
      });
    }

    this.anchor();

    /** Loader */
    const loader = document.querySelector(".loader");
    if (loader && Cookies.get("already-load") == undefined) {
      HTML.classList.add('loading')
      const nbAnim = setInterval(() => {
        if (document.readyState === "complete") {
          clearInterval(nbAnim);
          HTML.classList.add('loaded')
          tl.play();
        }
      }, 1250);

      const tl = gsap.timeline({
        paused: true,
        onComplete: () => {
          setTimeout(() => {
            this.init();
            gsap.to(loader, { autoAlpha: 0 });
            Cookies.set("already-load", true, { expires: 1 });
          }, 200)
        },
      });

      const icon = loader.querySelector(".icon");
      const bar = loader.querySelector(".bar");
      const welcome = loader.querySelector(".welcome");

      tl.fromTo(
        bar,
        {
          scaleY: 0,
          scaleX: 1,
          transformOrigin: 'top center'
        },
        {
          scaleY: 1,
          duration: 0.4,
          ease: 'circ.inOut',
          transformOrigin: 'top center'
        }
      )
      .fromTo(
        welcome, {
          autoAlpha: 0,
          y: '1rem'
        },
        { 
          autoAlpha: 1,
          ease: 'expo.out',
          y: '0rem',
          duration: 1,
        }
      )
    } else {
      gsap.set(loader, { autoAlpha: 0 });
      this.init();
    }
  }

  init() {
    this.portraits();
    this.tabs();
    this.carousel();
    this.accordion();
    this.steps();
    this.textareaResize();
    this.animation();
    this.inViewport();
  }

  animation() {
    const elts = document.querySelectorAll("[data-animation]");

    if (elts) {
      elts.forEach((el) => {
        const r = new Rive({
          src: el.dataset.animation,
          // Or the path to a public Rive asset
          // src: '/public/example.riv',
          canvas: el,
          autoplay: true,
          onLoad: () => {
            r.play();
            r.resizeDrawingSurfaceToCanvas();
          },
        });
      });
    }
  }

  anchor() {
    /** ANCHOR */
    const anchors = document.querySelectorAll(
      'a[href^="#"]:not([href="#"]), a[href^="/#"]:not([href="#"])'
    );

    const header = document.querySelector(".main-header");
    if (anchors) {
      anchors.forEach((anchor) => {
        anchor.addEventListener("click", (e) => {
          const target = document.querySelector(
            anchor.getAttribute("href").replace("/#", "#")
          );

          if (target) {
            e.preventDefault();
            let offset = 0;
            const bound = target.getBoundingClientRect();

            if (header) {
              offset = header.offsetHeight;
            }

            gsap.to(document.querySelectorAll("html, body"), {
              duration: 2,
              scrollTop: window.scrollY + bound.y - offset,
              ease: "expo.inOut",
            });
          }
        });
      });
    }
  }

  portraits() {
    const els = document.querySelectorAll(".portraits");

    if (els) {
      els.forEach((el) => {
        const portraits = el.querySelectorAll(".sportrait");
        const portraitsPhotos = el.querySelector(".portrait-photos");
        if (portraitsPhotos) {
          const tl = gsap.timeline();

          const photos = portraitsPhotos.querySelectorAll(".portrait-photo");
          if (photos) {
            photos.forEach((photo, i) => {
              if (i > 0) {
                tl.from(
                  photo.querySelector("figure"),
                  {
                    y: "100%",
                    duration: i * 0.5,
                    ease: "none",
                  },
                  "start"
                ).from(
                  photo.querySelector(".inner"),
                  {
                    y: "-100%",
                    scale: 1.2,
                    duration: i * 0.5,
                    ease: "none",
                  },
                  "start"
                );
              }
            });
          }

          ScrollTrigger.create({
            trigger: portraitsPhotos,
            start: "top top",
            end: `+=${el.offsetHeight}px bottom`,
            scrub: true,
            pin: true,
            animation: tl,
          });
        }

        // if (portraits) {
        //   let current = -1;
        //   function goto(index) {
        //     if (current >= 0 && portraits[current]) {
        //       const old = portraits[current];

        //       gsap.fromTo(
        //         old,
        //         {
        //           zIndex: 1,
        //         },
        //         {
        //           y: "-100%",
        //           autoAlpha: 1,
        //           rotate: "-7deg",
        //           scale: 1.2,
        //           ease: "expo.out",
        //           duration: 1.4,
        //           transformOrigin: "left top",
        //         }
        //       );
        //     }

        //     if (portraits[index]) {
        //       const p = portraits[index];

        //       gsap.fromTo(
        //         p,
        //         {
        //           zIndex: 2,
        //           y: "100%",
        //           autoAlpha: 1,
        //           rotate: "7deg",
        //           scale: 1.5,
        //           transformOrigin: "left top",
        //         },
        //         {
        //           y: "0%",
        //           rotate: "0deg",
        //           scale: 1,
        //           ease: "expo.out",
        //           duration: 1.4,
        //           transformOrigin: "left top",
        //         }
        //       );
        //     }

        //     current = index;
        //   }

        //   el.addEventListener("click", (e) => {
        //     e.preventDefault();

        //     const next = current == portraits.length - 1 ? 0 : current + 1;
        //     goto(next);
        //   });

        //   el.addEventListener("inview", () => {
        //     console.log();
        //     goto(0);
        //   });
        // }

        const carousels = el.querySelectorAll(".portrait-experiences");
        if (carousels) {
          carousels.forEach((carousel) => {
            new Flickity(carousel, {
              cellAlign: "left",
              cellSelector: ".item",
              prevNextButtons: false,
              adaptiveHeight: !(window.innerWidth > 768),
              on: {
                select(index) {},
              },
            });
          });
        }
      });
    }
  }

  tabs() {
    const els = document.querySelectorAll(".tabs");

    if (els) {
      els.forEach((el) => {
        let tl;
        const carousels = el.querySelectorAll(".carousel-tabs");
        const items = el.querySelectorAll(".tabs-item");

        if (carousels) {
          carousels.forEach((carousel) => {
            const prevNext = el.querySelectorAll(".carousel-nav .nav");
            const itemsCarousel = carousel.querySelectorAll(".item");
            const parent = carousel.closest(".tabs-item");
            let draw = false;
            let prevItem = -1;

            if (parent) {
              const circle = parent.querySelector(".carousel-circle");

              if (circle) {
                draw = circle.querySelector(".drawing");
                gsap.set(draw, { drawSVG: "0%" });

                const angle = 360 / itemsCarousel.length;
                let rot = 0;
                const circleSize = circle.offsetWidth;

                for (let i = 0; i < itemsCarousel.length; i++) {
                  const point = document.createElement("div");
                  point.innerHTML = '<span class="inner"></span>';
                  point.classList.add("point");
                  point.style.transform = `rotate(${rot}deg) translate(${
                    circleSize / 2
                  }px) rotate(${-rot}deg)`;
                  circle.append(point);

                  rot += angle;
                }
              }
            }

            const flkty = new Flickity(carousel, {
              wrapAround: true,
              prevNextButtons: false,
              cellSelector: ".item",
              on: {
                select(index) {
                  const nb = this.cells.length;
                  if (draw) {
                    if (prevItem < nb - 1) {
                      gsap.to(draw, {
                        drawSVG: `${(index / nb) * 100}%`,
                      });
                    } else {
                      gsap.to(draw, {
                        drawSVG: `100% 100%`,
                        onComplete: () => {
                          gsap.set(draw, { drawSVG: "0%" });
                        },
                      });
                    }
                  }
                },
                change(index) {
                  prevItem = index;
                },
              },
            });

            if (prevNext) {
              prevNext.forEach((n) => {
                n.addEventListener("click", (e) => {
                  e.preventDefault();

                  if (n.classList.contains("prev")) {
                    flkty.previous();
                  } else {
                    flkty.next();
                  }
                });
              });
            }
          });
        }

        if (items) {
          window.addEventListener("resize", () => {
            this.throttle(() => {
              killAll();
              initSticky();
            }, 250);
          });

          function killAll() {
            const scrolls = ScrollTrigger.getAll();
            if (scrolls) {
              for (const scroll_ of scrolls) {
                scroll_.kill(true);
              }
            }

            if (tl) {
              tl.kill(true);
              gsap.set(el, { clearProps: "all" });
            }

            if (items) {
              items.forEach((item) => {
                gsap.set(item, { clearProps: "all" });
              });
            }
          }
          function initSticky() {
            const hEl = el.offsetHeight;

            if (items && window.innerWidth >= 768) {
              let hContainer = 0;
              items.forEach((item, i) => {
                gsap.set(item, {
                  position: "absolute",
                  top: 0,
                });
                hContainer += item.offsetHeight;
              });
              gsap.set(el, { height: "90vh" });

              tl = gsap.timeline();

              let hPrev = 0;
              items.forEach((item, i) => {
                if (i > 0) {
                  const prev = items[i - 1];
                  hPrev += Number.parseFloat(prev.offsetHeight);
                  gsap.set(item, { y: hPrev });
                  tl.to(
                    item,
                    { y: 0, duration: i * 0.5, ease: "none" },
                    "start"
                  );
                }
              });

              let offset = 0;
              const mainHeader = document.querySelector(".main-header");
              if (mainHeader) offset += mainHeader.offsetHeight;

              ScrollTrigger.create({
                trigger: el,
                start: `top ${offset}px`,
                end: `+=${hEl}px bottom`,
                scrub: true,
                pin: true,
                animation: tl,
              });
            }
          }

          initSticky();
        }
      });
    }
  }

  carousel() {
    const els = document.querySelectorAll(".carousel, .slider");

    if (els) {
      els.forEach((el) => {
        const prevNext = el.querySelectorAll(".carousel-nav .nav");
        const bar = el.querySelector(".carousel-nav .progress .bar");

        const flkty = new Flickity(el, {
          cellAlign: "left",
          cellSelector: ".item",
          pageDots: false,
          prevNextButtons: false,
          on: {
            select(index) {
              prevNext.forEach((n) => {
                if (n.classList.contains("prev")) {
                  if (index == 0) {
                    n.classList.add("disabled");
                  } else {
                    n.classList.remove("disabled");
                  }
                } else if (index == this.cells.length - 1) {
                  n.classList.add("disabled");
                } else {
                  n.classList.remove("disabled");
                }
              });

              this.cells.forEach((cell, i) => {
                if (i < index) {
                  cell.element.classList.add("previous");
                } else {
                  cell.element.classList.remove("previous");
                }
              });
            },
            scroll(progress) {
              progress = Math.max(0, Math.min(1, progress));
              if (bar) {
                gsap.set(bar, { width: `${Math.round(progress * 100)}%` });
              }
            },
          },
        });

        window.addEventListener("resize", () => {
          flkty.cells.forEach(function (cell) {
            cell.element.style.height = `${flkty.maxCellHeight}px`;
          });
        });
        window.dispatchEvent(new Event("resize"));

        if (prevNext) {
          prevNext.forEach((n) => {
            n.addEventListener("click", (e) => {
              e.preventDefault();

              if (n.classList.contains("prev")) {
                flkty.previous();
              } else {
                flkty.next();
              }
            });
          });
        }
      });
    }
  }

  accordion() {
    const els = document.querySelectorAll(".accordion");

    if (els) {
      els.forEach((el) => {
        const headers = el.querySelectorAll(".accordion-header");
        const contents = el.querySelectorAll(".accordion-content");

        if (headers && contents) {
          headers.forEach((header, i) => {
            header.addEventListener("click", (e) => {
              e.preventDefault();

              header.parentElement.classList.toggle("open");

              if (contents[i] != undefined) {
                const isOpen = header.parentElement.classList.contains("open");

                gsap.to(contents[i], {
                  opacity: isOpen ? 1 : 0,
                  height: isOpen
                    ? `${contents[i].children[0].offsetHeight}px`
                    : "0px",
                  duration: 0.5,
                  ease: "circ.inOut",
                });
              }
            });
          });
        }
      });
    }
  }

  steps() {
    const els = document.querySelectorAll(".steps");

    if (els) {
      els.forEach((el) => {
        const steps = el.querySelectorAll(".step");
        const mainHeader = document.querySelector(".main-header");
        const progress = el.querySelector(".progress");
        let offset = 40;

        if (mainHeader) {
          offset += mainHeader.offsetHeight;
        }

        if (steps) {
          window.addEventListener("scroll", () => {
            steps.forEach((step) => {
              const bound = step.getBoundingClientRect();

              if (bound.y - offset <= 0) {
                step.classList.add("active");
              } else {
                step.classList.remove("active");
              }
            });

            if (progress) {
              const parent = progress.parentNode;
              const boundP = parent.getBoundingClientRect();

              if (boundP.y - offset <= 0) {
                console.log(boundP.height);
                console.log(boundP.y);
                console.log(boundP.bottom);
                // gsap.set(progress, { height: boundP.height - boundP.bottom });
              }
            }
          });
        }

        const title = el.querySelector(".steps-title");
        if (title) {
          ScrollTrigger.create({
            trigger: title,
            start: "top 50%",
            end: `bottom 50%`,
            scrub: true,
            pin: true,
          });
        }
      });
    }
  }

  textareaResize() {
    /**
     * Textarea
     */
    // expand height textarea
    function autoExpand(field) {
      // Reset field height
      field.style.height = "inherit";

      // Get the computed styles for the element
      const computed = window.getComputedStyle(field);

      // Calculate the height
      const height =
        Number.parseInt(computed.getPropertyValue("border-top-width"), 10) +
        // parseInt(computed.getPropertyValue('padding-top'), 10) +
        field.scrollHeight +
        // parseInt(computed.getPropertyValue('padding-bottom'), 10) +
        Number.parseInt(computed.getPropertyValue("border-bottom-width"), 10);

      field.style.height = `${height}px`;
    }

    document.addEventListener("input", (event) => {
      if (event.target.tagName.toLowerCase() !== "textarea") return;
      autoExpand(event.target);
    });
  }

  inViewport() {
    // In viewport
    inView.offset({
      bottom: window.innerHeight * 0.1,
    });
    inView(".js-reveal:not(.is-visible)")
      .on("enter", function (elt) {
        elt.dispatchEvent(new Event("inview"));
        elt.classList.add("is-visible");
        elt.classList.remove("not-visible");

        const video = elt.querySelector("video");

        if (
          (elt.tagName == "VIDEO" && elt.dataset.autoplay == "true") ||
          (video && video.dataset.autoplay == "true")
        ) {
          const v = video || elt;
          const playPromise = v.play();
          if (playPromise !== null) {
            playPromise.catch(() => {
              v.play();
            });
          }
        }
      })
      .on("exit", function (elt) {
        const video = elt.querySelector("video");
        if (
          (elt.tagName == "VIDEO" && elt.dataset.autoplay != "") ||
          (video && video.dataset.autoplay != "")
        ) {
          const v = video || elt;
          v.pause();
        }

        elt.dispatchEvent(new Event("outview"));
        elt.classList.add("not-visible");
      });
  }

  throttle(func, delay) {
    if (timerThrottle) {
      window.clearTimeout(timerThrottle);
    }
    timerThrottle = window.setTimeout(func, delay);
  }
}

window.addEventListener("DOMContentLoaded", () => {
  new App();
});
